import { dispatch } from '../store/'
import { FETCH_MYAPPLICATIONS } from '../constants/actionTypes'
import { myApplicationsRef } from '../firebase/db'
import { doDeleteApplication } from '../firebase/database/handleApplications'

export const delApplication = (eventId, userId) => {
    doDeleteApplication(eventId, userId)

    // muss nicht weil fb listener - dispatch({type: DELETE_APPLICATION, payload})
}

export const fetchMyApplications = (userId) => {
    
    myApplicationsRef(userId).on('value', snap => {
            const payload=snap.val()
            dispatch({type: FETCH_MYAPPLICATIONS, payload})
        
    })
}







// WEBPACK FOOTER //
// ./src/actions/applications.js